"use client";
import { useEffect, useRef, useState } from "react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Tabs, Row, Col } from "antd";
import type { TabsProps } from 'antd';
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from 'swiper';
import useMobileDetect from "@/hooks/useMobileDetect";
import { handleCardClick } from "@/utils/tools";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

import './index.css'
import "swiper/css";
import "swiper/css/pagination";

type mediaCardListProps = {
  isFirstMobile?: boolean,
  list: any[],
  // title?: string,
  // subTitle?: string,
  cardInfo: any
}

const imgNumberTOSize: { [key: number]: string[] } = {
  3: ['960/1280', '133.333%'],
  2: ['1440/1280', '88.888%'],
  1: ['2880/1280', '44.444%']
}

const imgNumberTOSize_Mobile = ["1125/1500", '133.333%']
export const MediaCardList: React.FC<mediaCardListProps> = ({ isFirstMobile, list, cardInfo }) => {
  const isMobile = useMobileDetect(isFirstMobile);
  // const [activeTab, setActiveTab] = useState(0);
  // const swiperRef = useRef<SwiperType | null>(null);

  // const items: TabsProps['items'] = list.map((item: {
  //   tabName: string
  // }, idx: number) => ({
  //   key: idx.toString(),
  //   label: item.tabName,
  //   children: false
  // }))

  // 切换到指定索引的幻灯片
  // const goToSlide = (index: number) => {
  //   if (swiperRef.current) {
  //     swiperRef.current.slideTo(index); // 调用 slideTo 方法
  //     setActiveTab(index); // 更新当前索引状态
  //   }
  // };

  // const onChange = (key: string) => {
  //   const idx = parseInt(key)
  //   setActiveTab(idx)
  //   goToSlide(idx)
  // };

  return (<div className="MediaCardList">
    {
      cardInfo?.title ?
        <h2 className={`text-bravve-100 font-bold leading-32  ${isMobile ? 'text-[22px]' :
          'text-4.2xl'} ${cardInfo?.description ? isMobile ? 'mb-8' : 'mb-12' : isMobile ? 'mb-24' : 'mb-56'} mx-20 md:mx-40 `}>
          {cardInfo?.title}
        </h2>
        :
        null
    }
    {
      cardInfo?.description ?
        <h3 className={`text-bravve-sub-100 leading-22 text-base ${isMobile ? 'mb-24' : 'mb-56'} mx-20 md:mx-40 `}>
          {cardInfo?.description}
        </h3>
        :
        null
    }

    {
      isMobile ?
        <Swiper
          className="MediaCardListCarousel"
          modules={list.length > 1 ? [Pagination] : []}
          // onSwiper={(swiper) => {
          //   swiperRef.current = swiper; // 存储 Swiper 实例
          // }}
          // onSlideChange={(swiper) => {
          //   setActiveTab(swiper.activeIndex); // 更新当前索引状态
          // }}
          pagination={{
            clickable: true
          }}
        >
          {list.map(
            (item: {
              pc_pic: string,
              h5_pic: string,
              alt_text: string,
              name: string,
              link?: string,
              link_type?: string,
              open_type?: string,
            }, idx: number) => {
              return (
                <SwiperSlide key={item.h5_pic}>
                  {
                    handleCardClick({ ...item, idx },
                      <div className="relative w-full" 
                        style={{ aspectRatio: imgNumberTOSize_Mobile[0], paddingTop: imgNumberTOSize_Mobile[1] }}>
                        <ImageWithSkeleton
                          src={process.env.NEXT_PUBLIC_IMAGE_URL + item.h5_pic}
                          alt={item.alt_text || item.name}
                          width={100}
                          height={100}
                        />
                      </div>
                      , isMobile)
                  }
                </SwiperSlide>
              );
            }
          )}
        </Swiper>
        :
        <Row>
          {
            list.map((item, idx: number) => {
              return <Col key={item.pc_pic} span={24 / cardInfo.pic_amount}>
                {
                  handleCardClick({ ...item, idx },
                    <div className="relative w-full" 
                      style={{ aspectRatio: imgNumberTOSize[cardInfo.pic_amount][0], 
                        paddingTop: imgNumberTOSize[cardInfo.pic_amount][1] }}>
                      <ImageWithSkeleton
                        src={process.env.NEXT_PUBLIC_IMAGE_URL + item.pc_pic}
                        alt={item.alt_text}
                        width={100}
                        height={100}
                      />
                    </div>
                    // <Image src={process.env.NEXT_PUBLIC_IMAGE_URL + item.pc_pic}
                    //   alt={item.alt_text}
                    //   width={100} 
                    //   height={100} 
                    //   loading="lazy"
                    //   className="ant-skeleton-image-self"
                    //   style={{ width: '100%', height: 'auto' }} 
                    // />
                    ,
                    isMobile
                  )
                }
              </Col>
            })
          }
        </Row>
    }

  </div>)
}